export default "/images/alka.webp?8ec71a7f850e12cf1bf78e6c7d2fe600";